import styled from "styled-components/macro";

export const BodyLabelLink = styled.span`
  color: ${({ theme }) => theme.color.brandPrimary.light};
  margin-bottom: 4px;
`;

export const NavigationLinkItemStyled = styled.a`
  width: 100%;
  height: 100%;
  text-decoration: none !important;
`;

export const NavigationCardItemStyled = styled.div`
  & .Card__Body {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  & .Card__Body > div {
    width: 100%;
    max-width: 90%;
  }
`;

export const TipoSeguroCard = styled.div`
  height: fit-content;
  max-width: 384px;
`;

export const NumeroSorteado = styled.h1`
  color: ${({ theme }) => theme.color.highlight["03"]};
`;

export const NumeroSorteadoLabel = styled.p`
  color: ${({ theme }) => theme.color.neutral["03"]};
  margin-right: 32px;
`;

export const RowContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const SelectAno = styled.select`
  margin-right: 32px;
  width: 176px;
`;

export const SelectData = styled.select`
  width: 176px;
`;

export const NumeroSorteadoContainer = styled.div`
  background-color: #f7f9fa;
  margin-bottom: 32px;
  padding: 20px 16px;
`;
